import { setWasmUrl } from '@lottiefiles/dotlottie-react';

// Override the default jsdelivr/unpkg CDN load — serve the WASM from our own
// origin so we are not dependent on external CDNs for security-sensitive binaries.
//
// The WASM file is copied into public/ by scripts/postinstall/copy-lottie-wasm.js.
// See: https://github.com/LottieFiles/dotlottie-web/discussions/198
setWasmUrl('/dotlottie-player.wasm');
